<template>
    <div v-if="showPopup" class="popup-overlay">
        <div class="popup-content">
            <h2>{{ popup.title.rendered }}</h2>

            <a v-if="popup.acf.link_destino" :href="popup.acf.link_destino" target="_blank" class="popup-link">
                <div v-for="(conteudo, index) in popup.acf.conteudos" :key="index">
                    <div v-if="conteudo.acf_fc_layout === 'imagem_destaque'" class="img-container">
                        <img :src="conteudo.imageUrl" alt="Imagem de Destaque" class="popup-image" />
                    </div>

                    <div v-if="conteudo.acf_fc_layout === 'editor_de_texto'">
                        <div v-html="conteudo.conteudo_do_popup"></div>
                    </div>
                </div>
            </a>

            <button @click="closePopup" class="close-btn">+</button>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            popup: null,
            showPopup: false,
        };
    },
    async mounted() {
        try {
            const response = await axios.get("https://api.cref20.org.br/wp-json/wp/v2/popup");
            const popups = response.data;

            const popupValido = popups.find(p => p.acf?.link_destino);

            if (popupValido) {
                this.popup = popupValido;
                await this.loadImageUrls();
                this.showPopup = true;
                document.body.style.overflow = "hidden";
            }
        } catch (error) {
            console.error("Erro ao buscar popups:", error);
        }
    },
    methods: {
        closePopup() {
            this.showPopup = false;
            document.body.style.overflow = "auto";
        },
        async getImageUrl(imagemID) {
            try {
                const { data } = await axios.get(`https://api.cref20.org.br/wp-json/wp/v2/media/${imagemID}`);
                return data.guid.rendered;
            } catch (error) {
                console.error('Erro ao buscar imagem:', error);
                return '';
            }
        },
        async loadImageUrls() {
            const conteudos = this.popup.acf?.conteudos || [];

            await Promise.all(conteudos.map(async (conteudo) => {
                if (conteudo.acf_fc_layout === 'imagem_destaque' && conteudo.imagem) {
                    conteudo.imageUrl = await this.getImageUrl(conteudo.imagem);
                }
            }));
        }
    }
};
</script>



<style scoped>
.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999999;
}

.popup-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    max-width: 780px;
}

.popup-image {
    width: 100%;
    max-height: 70vh;
}

.close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #f44336;
    /* Leve tom de vermelho */
    color: #fff;
    border: none;
    width: 28px;
    height: 28px;
    border-radius: 28px;
    /* Botão arredondado */
    font-size: 24px;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
}

.close-btn:hover {
    background-color: #e53935;
    /* Cor de hover levemente mais escura */
}

.close-btn:focus {
    outline: none;
    /* Remove outline padrão */
}

.close-btn {
    transform: rotate(45deg);
    /* Gira o botão em 45 graus */
}

/* TABLET */
@media (min-width: 766px) and (max-width: 1360px) {
    .popup-image {
        width: 448px;
    }
}

@media (max-width: 765px) {
    .popup-image {
        width: 480px;
    }
}
</style>